import React, { useState, useEffect } from "react";
import DeletedUsersList from "./DeletedUsersList/DeletedUsersList";
import { getApiCaller, postApiCaller, deleteApiCaller } from "../../../../Libs/apiCaller";
import { toast } from "react-toastify";

export default function DeletedUsers() {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalUsers, setTotalUsers] = useState(0);
    const [selectedTime, setSelectedTime] = useState("");

    useEffect(() => {
        setIsLoading(true);
        getDeletedUserList(1, selectedTime);
    }, [selectedTime]);

    const getDeletedUserList = async (page = 1, selTime = selectedTime) => {
        let endPoint = `users/deleted?page=${page}&limit=10`;
        if (selTime) endPoint += `&sortType=${selTime}`;

        const response = await getApiCaller(endPoint);
        if (response.status === 200) {
            window.scrollTo(0, 0);
            setCurrentPage(response.data.pagination.currentPage);
            setUserList(response.data.users);
            setTotalUsers(response.data.pagination.totalUsers);
            setTotalPages(response.data.pagination.totalPages);
        }
        setIsLoading(false);
    };

    const restoreUser = async () => {
        if (!selectedUser) {
            toast.error("User not found");
            return false;
        }

        const endpoint = `users/restore/${selectedUser._id}`;
        const response = await postApiCaller(endpoint, {});

        if (response.status === 200) {
            toast.success("User restored successfully");
            setUserList((prev) =>
                prev.filter((user) => user._id !== selectedUser._id)
            );
            setSelectedUser(null);
            return true;
        } else {
            toast.error(response?.response?.data?.message || response.message);
            return false;
        }
    };

    const hardDeleteUser = async () => {
        if (!selectedUser) {
            toast.error("User not found");
            return false;
        }

        const endpoint = `users/hard-delete/${selectedUser._id}`;
        const response = await deleteApiCaller(endpoint);

        if (response.status === 200) {
            toast.success("User permanently deleted");
            setUserList((prev) =>
                prev.filter((user) => user._id !== selectedUser._id)
            );
            setSelectedUser(null);
            return true;
        } else {
            toast.error(response?.response?.data?.message || response.message);
            return false;
        }
    };

    return (
        <section className="p-2">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-semibold text-black">Deleted Users</h1>
            </div>

            <DeletedUsersList
                selectedTime={selectedTime}
                setSelectedTime={setSelectedTime}
                setSelectedUser={setSelectedUser}
                userList={userList}
                isLoading={isLoading}
                getDeletedUserList={getDeletedUserList}
                currentPage={currentPage}
                totalPages={totalPages}
                totalUsers={totalUsers}
                restoreUser={restoreUser}
                hardDeleteUser={hardDeleteUser}
            />
        </section>
    );
}
